import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.page.html',
  styleUrls: ['./select.page.scss'],
})
export class SelectPage implements OnInit {

  
  @Input() remove_team_members = [];
  @Input() selecting_for_company = false;
  @Input() selecting_for_projects = false;
  @Input() in_team_members = [];

  @Input() source_header = 'Available';
  @Input() target_header = 'Selected To Add';
  @Input() modal_title = 'Select Team Members';

  @Input() selected_team_members: any = [];

  @Input() selecting_for_billing = false;
  team_members: any = [];

  roles: any = [];
  billing_rates: any = [];
  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  ngOnInit() {
    this.GetData();
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async GetData() {
    if (this.selecting_for_company) await this.GetRoles();
    if(this.selecting_for_billing) await this.GetBillingRates();
    console.log("selected_team_members", this.selected_team_members);
    if (this.in_team_members.length == 0)
      await this.GetTeamMembers();
    else
      this.team_members = this.in_team_members;

    if (this.selecting_for_company) this.SetRoles();
    if(this.selecting_for_projects) this.SetProjectRoles();
  }

  async GetTeamMembers() {
    console.log("Get Team Members");
    let data: any = await this.apiService.get('team_members');
    console.log(data);
    if (data.success) {
      this.team_members = data.data;
      //Filter out the team_members from the remove list
      if(this.remove_team_members && this.remove_team_members.length >= 0) {
        for (let i = 0; i < this.remove_team_members.length; i++) {
          let index = this.globalService.GetArrayIndex(this.team_members, this.remove_team_members[i].guid);
          if (index >= 0) this.team_members.splice(index, 1);
        }
      }
      
    }
  }

  async GetRoles() {
    let data: any = await this.apiService.get('firms/team_members/roles');
    if (data.success) {
      this.roles = data.data;
    }
  }

  async GetBillingRates() {
    let data: any = await this.apiService.get('billing/rates');
    if (data.success) {
      this.billing_rates = data.data;
      console.log(this.billing_rates);
    }
  } 

  async SetRoles() {
    for (let i = 0; i < this.team_members.length; i++) {
      this.team_members[i].role_guid = this.roles[0].guid;
    }
  }

  async SetProjectRoles() {
    for (let i = 0; i < this.team_members.length; i++) {
      this.team_members[i].role = 2; // Default to Worker (Main)
    }
  }
  async Finish() {
    console.log(this.selected_team_members);
    let allow_finish = true;
    let errSTR = "";
    if(this.selecting_for_billing) {
      this.selected_team_members.forEach(element => {
        if(!element.rate) {
          allow_finish = false;
          errSTR = "All assigned team members must have a rate";
        }
        else {
          element.rate_guid = element.rate.guid;
        }
      });
    }
    if(allow_finish) this.modalController.dismiss(this.selected_team_members);
    else this.globalService.presentToastMessage(errSTR,false);

  }

  async Log() {
    console.log(this.team_members);
    console.log(this.selected_team_members);
  }

}
